<template>
  <svg width="34px" height="34px" viewBox="0 0 34 34" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>shopping</title>
    <desc>Created with Sketch.</desc>
    <g id="neighborhood" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="neighborhood-poi-desktop" transform="translate(-801.000000, -798.000000)">
        <g id="map" transform="translate(0.000000, 612.000000)">
          <g id="POIs">
            <g transform="translate(771.000000, 107.000000)">
              <g id="shopping" transform="translate(32.000000, 81.000000)">
                <circle id="Oval-Copy-5" stroke="#FFFFFF" stroke-width="2" fill="#9F8054" cx="15" cy="15" r="16"></circle>
                <path d="M18.2502008,12.3213785 C17.658452,12.3213785 17.1787939,11.841689 17.1787939,11.2499715 C17.1787939,10.658254 17.658452,10.1785645 18.2502008,10.1785645 C18.8419183,10.1785645 19.3216078,10.658254 19.3216078,11.2499715 C19.3216078,11.841689 18.8419183,12.3213785 18.2502008,12.3213785 M21.4644218,7.5 L15.5716677,7.5 C15.4296003,7.5 15.2933712,7.55650053 15.1929258,7.6569773 L7.15729502,15.6926081 C6.94796056,15.9016915 6.94777222,16.240883 7.15688696,16.4502174 C7.15701252,16.450343 7.15716946,16.4504999 7.15729502,16.4506255 L13.0500805,22.3434109 C13.2592894,22.5525257 13.5983867,22.5525257 13.8075642,22.3434109 L21.843195,14.3077801 C21.9437974,14.2072092 22.0001725,14.0707604 22.0001725,13.9285046 L22.0001725,8.03571918 C22.0001725,7.73984475 21.7603276,7.5 21.4644218,7.5" id="Fill-1" fill="#FFFFFF"></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconPoiShopping',
};
</script>

<style></style>
